import '@/js/common/plugins/polyfill';
import '@travelata-libs/ui-kit/dist/sideEffects.js';
import '@travelata-libs/ui-kit/dist/index.css';
import '@travelata-libs/ui-shared/dist/index.css';
import '@travelata-libs/travelata-frontend/dist/index.css'
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';
import { mountSwitchCityToFooter } from '@entities/switch-city';

import '@/css/desktop/layout.scss';

import '@/js/common/Domain/Service/disableConsole';
import addTravelataClassTheme from '@/js/common/Service/addTravelataClassTheme';
import setGaAb from '@/js/common/Domain/Service/setGaAb';
import '@/js/common/plugins/jquery-ui';
import '@/js/common/plugins/logger'; //TODO track
import '@/js/common/Domain/Service/tracking/trackingUserVisit';
import '@/js/common/Domain/Service/tracking/trackingCoreWebVitals';
import '@/js/common/Domain/Service/mixins/mixins';
import '@/js/common/Domain/Model/ExtendEpoxyView';
import '@/js/common/Domain/Model/BackboneMapState';
import '@/js/desktop/plugins/jquery.serialize-object.min';
import initTravelataFrontendLib from '@/js/common/Service/initTravelataFrontendLib';
import { globalTrackingErrorsVue, useVueTeleport } from '@app/lib';
import './common';
initTravelataFrontendLib();
globalTrackingErrorsVue();
useVueTeleport();
addTravelataClassTheme();
mountSwitchCityToFooter();

setGaAb();
